import React from "react";
import { Col, Row, Form } from "antd";
import LocationSearch from "../../../../components/LocationSearch";

const { Item } = Form;

const Address = ({ setLocationInfo }) => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Address</h4>
      </Col>
      <Col xs={24} md={20}>
        <Item name="address">
          <LocationSearch
            placeholder="Your Address"
            name="address"
            setLocationInfo={setLocationInfo}
          />
        </Item>
      </Col>
    </Row>
  );
};

export default Address;
